import React, { Component } from 'react';
import propTypes from 'prop-types';
import axios from 'axios';

import calendarImg from '../../../assets/icons/black/calendar.png';
import phoneImg from '../../../assets/icons/black/phone.png';
import emailImg from '../../../assets/icons/black/email.png';
import SPListItem from './SPListItem';


export default class ModuleSP extends Component {

  copyName = () => {
    let copyText = document.getElementById("copyBody");
    copyText.style.display = 'inline';
    copyText.select();
    document.execCommand("copy");
    copyText.style.display = 'none';
    alert("Copied  " + copyText.value + "'s Name!");
  }

  // Render
  // ----------------------------------------------------
  render() {
    const { spList } = this.props;

    let spNumber = this.props.spNumber;
    let spI = spList.map(e => e.fields.Number).indexOf(spNumber);
    if (!spList[spI]) {spI = 0;}
    console.log(spList);
    console.log(spNumber);
    console.log(spList[spI]);


    let theInputVal = '';
    if (spList != undefined && spList.length > 0 && spNumber) {
      theInputVal = spList[spI].fields['SP Name'];
    }
    return (
      <div className="ModuleCard moduleSP">
        <div className="inner">

          <div className="inputBlock inputBlock--full">
            <label>Service Provider</label>
            <div
              className="selectBlock"
              id="status"
              >
              <select id="spSelector" value={this.props.spNumber} onChange={this.props.spChangeHandler}>
                <option value="none">Select SP</option>
                {spList.map((e, i) => this.spListItem(e, i))}
              </select>
            </div>
          </div>

          <a onClick={this.copyName}>Copy Name</a>
          <input className="hiddenSPName" id="copyBody" value={theInputVal} />
          <hr />

          {spList && this.props.spNumber && spList.length > 0 ? this.homePhone : ''}
          {spList && this.props.spNumber && spList.length > 0 ? this.cellPhone : ''}
          {spList && this.props.spNumber && spList.length > 0 ? this.emailLink : ''}
          {spList && this.props.spNumber && spList.length > 0 ? this.spButton : ''}


        </div>
      </div>
    );
  }

  spListItem(spList, index) {
    return <SPListItem
        key={this.props.spList.id}
        id={this.props.spList.id}
        spList={spList.fields}
        index={index}
      />
  }

  get homePhone() {
    let spList = this.props.spList;
    let spNumber = this.props.spNumber;
    let spI = spList.map(e => e.fields.Number).indexOf(spNumber);
    if (!spList[spI]) {spI = 0;}
    if (spList && this.props.spNumber && spList[spI].fields['Home Phone']) {
      return (
        <div className="inputBlock inputBlock--half">
          <label>Home Phone</label>
          <input
            disabled
            type="text"
            value={spList[spI].fields['Home Phone']}
          />
        </div>
      );
    } else {
      return (
        <div className="inputBlock inputBlock--half">
          <label>Home Phone</label>
          <input
            disabled
            type="text"
            value=" "
          />
        </div>
      );
    }
  }
  get cellPhone() {
    let spList = this.props.spList;
    let spNumber = this.props.spNumber;
    let spI = spList.map(e => e.fields.Number).indexOf(spNumber);
    if (!spList[spI]) {spI = 0;}
    if (spList && this.props.spNumber && spList[spI].fields['Cellphone']) {
      return (
        <div className="inputBlock inputBlock--half">
          <label>Cellphone</label>
          <input
            disabled
            type="text"
            value={spList[spI].fields['Cellphone']}
          />
        </div>
      );
    } else {
      return (
        <div className="inputBlock inputBlock--half">
          <label>Cellphone</label>
          <input
            disabled
            type="text"
            value=" "
          />
        </div>
      );
    }
  }
  get emailLink() {
    let spList = this.props.spList;
    let spNumber = this.props.spNumber;
    let spI = spList.map(e => e.fields.Number).indexOf(spNumber);
    if (!spList[spI]) {spI = 0;}
    if (spList && this.props.spNumber && spList[spI].fields['Cellphone']) {
      return (
        <div className="inputBlock inputBlock--full">
          <label>Email</label>
          <input
            disabled
            type="text"
            value={spList[spI].fields['Email']}
          />
        </div>
      );
    } else {
      return (
        <div className="inputBlock inputBlock--full">
          <label>Email</label>
          <input
            disabled
            type="text"
            value=" "
          />
        </div>
      );
    }
  }

  get spButton() {
    let spList = this.props.spList;
    let spNumber = this.props.spNumber;
    let spI = spList.map(e => e.fields.Number).indexOf(spNumber);
    if (!spList[spI]) {spI = 0;}
    if (this.props.baseId === 'appBUKBn552B8SlbE') {
      return (
        <div className="cardTag">
          <a className="btn softGrad--primary" href={'/orlando/franchisees/' + spList[spI].fields['id']} target="_blank">View SP Record</a>
        </div>
      )
    } else {
      return (
        <div className="cardTag">
          <a className="btn softGrad--primary" href={'/tampa/franchisees/' + spList[spI].fields['id']} target="_blank">View SP Record</a>
        </div>
      )
    }
  }
}

ModuleSP.propTypes ={
  spChangeHandler: propTypes.func.isRequired,
  spNumber: propTypes.string,
  baseId: propTypes.string,
  changeRecordHandler: propTypes.func.isRequired,
  changeSelectBlock: propTypes.func.isRequired,
  currentSP: propTypes.object.isRequired,
  spList: propTypes.object.isRequired,
}



// WEBPACK FOOTER //
// ./src/CustomerService/Records/Modules/ModuleSP.js